// Bias helpers
export function getBiasLabel(bias) {
  if (bias < -18) return 'Far Left'
  if (bias < -12) return 'Left'
  if (bias < -6) return 'Leans Left'
  if (bias < 6) return 'Center'
  if (bias < 12) return 'Leans Right'
  if (bias < 18) return 'Right'
  return 'Far Right'
}

export function getBiasColor(bias) {
  if (bias < -18) return 'bg-blue-700'
  if (bias < -12) return 'bg-blue-600'
  if (bias < -6) return 'bg-blue-400'
  if (bias < 6) return 'bg-zinc-400'
  if (bias < 12) return 'bg-red-400'
  if (bias < 18) return 'bg-red-600'
  return 'bg-red-700'
}

// Reliability helpers
export function getReliabilityLabel(reliability) {
  if (reliability >= 40) return 'Reliable'
  if (reliability >= 32) return 'Mostly Reliable'
  if (reliability >= 24) return 'Mixed'
  return 'Unreliable'
}

export function getReliabilityDots(reliability) {
  if (reliability >= 40) return 4
  if (reliability >= 32) return 3
  if (reliability >= 24) return 2
  return 1
}

// Access helpers
export function getAccessConfig(access) {
  switch (access) {
    case 'Paid':
      return {
        label: 'Paid',
        className: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
        tooltip: 'Requires a subscription to access content',
      }
    case 'Limited':
      return {
        label: 'Limited',
        className: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
        tooltip: 'Limited free articles per month',
      }
    default:
      return {
        label: 'Free',
        className: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
        tooltip: 'Free to access',
      }
  }
}
